import { Injectable, inject } from "@angular/core";
import { HttpClient, HttpBackend } from "@angular/common/http";
import { map } from "rxjs/operators";
import { firstValueFrom } from "rxjs";
import { Language } from "@app/user/user-profile/shared/language.enum";

/** Non-auth client bootstrap config served by GET /api/client-config. */
export interface ClientConfig {
    i18nToolingEnabled: boolean;
    defaultLanguage: Language | null;
}

@Injectable({
    providedIn: "root",
})
export class ClientConfigService {
    private clientConfig: ClientConfig;
    // Bypass interceptors: this runs at bootstrap before dependent services exist.
    private httpClient = new HttpClient(inject(HttpBackend));

    get i18nToolingEnabled(): boolean {
        return this.clientConfig?.i18nToolingEnabled ?? false;
    }

    /** The tenant's default language, or null if no admin has set one. */
    get defaultLanguage(): Language | null {
        return this.clientConfig?.defaultLanguage ?? null;
    }

    public initialize(): Promise<ClientConfig> {
        return firstValueFrom(this.httpClient
            .get<ClientConfig>("/api/client-config")
            .pipe(
                map((value) => {
                    this.clientConfig = value;
                    return value;
                }),
            ));
    }
}
